import { render, staticRenderFns } from "./yuTeamItem.vue?vue&type=template&id=57998908&scoped=true&"
import script from "./yuTeamItem.vue?vue&type=script&lang=js&"
export * from "./yuTeamItem.vue?vue&type=script&lang=js&"
import style0 from "./yuTeamItem.vue?vue&type=style&index=0&id=57998908&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57998908",
  null
  
)

export default component.exports